import React from 'react';
import styled from 'styled-components';

import Avatar from 'antd/es/avatar';
import Badge from 'antd/es/badge';

import Icon from 'components/Icon';

import { formatDistanceToNow } from 'helpers/date';

const notificationColors = {
  black: '#232526',
  green: '#52C41A',
  orange: '#FAAD14',
  yellow: '#FAAD14',
  red: '#F5222D',
  blue: '#42B0D5',
  grey: '#828C94',
};

const Notification = ({ item }) => {
  let notificationAvatar = (
    <NotificationAvatar
      size="large"
      shape="square"
      color={item.color}
    >
      {item.door_name}
    </NotificationAvatar>
  );

  if (item.is_read === 0) {
    notificationAvatar = (
      <Badge dot style={{ boxShadow: '0 0 0 3px #fff', width: '8px', height: '8px' }}>
        {notificationAvatar}
      </Badge>
    );
  }

  return (
    <NotificationWrapper className="notification-wrapper">
      {notificationAvatar}
      <MessageWrapper>
        <MessageTitleWrapper>
          {item.notification_type === 'missing_tags' && (
            <Icon
              name="user"
              size={13}
              fill="#CF1322"
              color="white"
              strokeWidth="2"
              style={{
                backgroundColor: '#CF1322',
                borderRadius: '32px',
                width: '20px',
                height: '20px',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '8px',
              }}
            />
          )}
          <span style={{ color: '#232526', fontWeight: 600 }}>
            {item.title}
          </span>
          {item.date_created && (
            <span style={{ color: '#828C94', fontSize: '12px', lineHeight: '20px', marginLeft: 'auto' }}>
              {`${formatDistanceToNow(item.date_created)} ago`}
            </span>
          )}
        </MessageTitleWrapper>
        {item.content_msg && <span style={{ color: '#828C94' }}>
          {item.content_msg}  
        </span>}
      </MessageWrapper>
    </NotificationWrapper>
  );
};

const NotificationAvatar = ({ color, ...rest }) => {
  const avatarStyles ={
    backgroundColor: notificationColors[color] || notificationColors.grey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <StyledAvatar style={avatarStyles} {...rest} />
  );
};

const NotificationWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 8px;
`;

const MessageWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 8px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
`;

const MessageTitleWrapper = styled.div`
  flex: 1;
  display: inline-flex;
  margin-top: -2px;
`;

const StyledAvatar = styled(Avatar)`
  min-width: 40px;
  min-height: 40px;

  & .ant-avatar-string {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #FFFFFF;
  }
`;

export default Notification;
